import { render, staticRenderFns } from "./Cam.vue?vue&type=template&id=01b8363a&scoped=true&"
import script from "./Cam.vue?vue&type=script&lang=js&"
export * from "./Cam.vue?vue&type=script&lang=js&"
import style0 from "./Cam.vue?vue&type=style&index=0&id=01b8363a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b8363a",
  null
  
)

component.options.__file = "Cam.vue"
export default component.exports